 
import * as Types from '../schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetMenuCategoriesDocument = gql`
    query GetMenuCategories($menuId: Int, $locale: String, $branchId: Int!, $typeMenu: MenuTypeType, $typeMenuItems: String) {
  menu(menuId: $menuId, branchId: $branchId, type: $typeMenu) {
    categories {
      id
      name(locale: $locale)
      nameOrigin
      menuItems(menuId: $menuId, branchId: $branchId, type: $typeMenuItems) {
        id
      }
      favicon {
        id
        path
      }
      parentCategory {
        id
        name(locale: $locale)
        nameOrigin
        favicon {
          id
          path
        }
      }
    }
    status {
      id
      name
      slug
    }
  }
}
    `;

/**
 * __useGetMenuCategoriesQuery__
 *
 * To run a query within a React component, call `useGetMenuCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuCategoriesQuery({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      locale: // value for 'locale'
 *      branchId: // value for 'branchId'
 *      typeMenu: // value for 'typeMenu'
 *      typeMenuItems: // value for 'typeMenuItems'
 *   },
 * });
 */
export function useGetMenuCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables> & ({ variables: GetMenuCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>(GetMenuCategoriesDocument, options);
      }
export function useGetMenuCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>(GetMenuCategoriesDocument, options);
        }
export function useGetMenuCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>(GetMenuCategoriesDocument, options);
        }
export type GetMenuCategoriesQueryHookResult = ReturnType<typeof useGetMenuCategoriesQuery>;
export type GetMenuCategoriesLazyQueryHookResult = ReturnType<typeof useGetMenuCategoriesLazyQuery>;
export type GetMenuCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetMenuCategoriesSuspenseQuery>;
export type GetMenuCategoriesQueryResult = Apollo.QueryResult<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>;
export const GetInfoBranchForCategoriesPageDocument = gql`
    query GetInfoBranchForCategoriesPage($menuId: Int, $branchId: Int!, $typeMenu: MenuTypeType) {
  menu(menuId: $menuId, branchId: $branchId, type: $typeMenu) {
    branch {
      name
      image
      type {
        name
      }
    }
  }
}
    `;

/**
 * __useGetInfoBranchForCategoriesPageQuery__
 *
 * To run a query within a React component, call `useGetInfoBranchForCategoriesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoBranchForCategoriesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoBranchForCategoriesPageQuery({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      branchId: // value for 'branchId'
 *      typeMenu: // value for 'typeMenu'
 *   },
 * });
 */
export function useGetInfoBranchForCategoriesPageQuery(baseOptions: Apollo.QueryHookOptions<GetInfoBranchForCategoriesPageQuery, GetInfoBranchForCategoriesPageQueryVariables> & ({ variables: GetInfoBranchForCategoriesPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInfoBranchForCategoriesPageQuery, GetInfoBranchForCategoriesPageQueryVariables>(GetInfoBranchForCategoriesPageDocument, options);
      }
export function useGetInfoBranchForCategoriesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoBranchForCategoriesPageQuery, GetInfoBranchForCategoriesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInfoBranchForCategoriesPageQuery, GetInfoBranchForCategoriesPageQueryVariables>(GetInfoBranchForCategoriesPageDocument, options);
        }
export function useGetInfoBranchForCategoriesPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInfoBranchForCategoriesPageQuery, GetInfoBranchForCategoriesPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInfoBranchForCategoriesPageQuery, GetInfoBranchForCategoriesPageQueryVariables>(GetInfoBranchForCategoriesPageDocument, options);
        }
export type GetInfoBranchForCategoriesPageQueryHookResult = ReturnType<typeof useGetInfoBranchForCategoriesPageQuery>;
export type GetInfoBranchForCategoriesPageLazyQueryHookResult = ReturnType<typeof useGetInfoBranchForCategoriesPageLazyQuery>;
export type GetInfoBranchForCategoriesPageSuspenseQueryHookResult = ReturnType<typeof useGetInfoBranchForCategoriesPageSuspenseQuery>;
export type GetInfoBranchForCategoriesPageQueryResult = Apollo.QueryResult<GetInfoBranchForCategoriesPageQuery, GetInfoBranchForCategoriesPageQueryVariables>;
export type GetMenuCategoriesQueryVariables = Types.Exact<{
  menuId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
  branchId: Types.Scalars['Int']['input'];
  typeMenu?: Types.InputMaybe<Types.MenuTypeType>;
  typeMenuItems?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMenuCategoriesQuery = { __typename?: 'menuQuery', menu: { __typename?: 'MenuProxy', categories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, menuItems?: Array<{ __typename?: 'MenuItemProxy', id: number }> | null, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, path?: string | null } | null, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, path?: string | null } | null } | null }> | null, status: { __typename?: 'MenuStatusProxy', id: number, name: string, slug: string } } };

export type GetInfoBranchForCategoriesPageQueryVariables = Types.Exact<{
  menuId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  branchId: Types.Scalars['Int']['input'];
  typeMenu?: Types.InputMaybe<Types.MenuTypeType>;
}>;


export type GetInfoBranchForCategoriesPageQuery = { __typename?: 'menuQuery', menu: { __typename?: 'MenuProxy', branch: { __typename?: 'BranchProxy', name: string, image?: string | null, type?: { __typename?: 'BranchTypeProxy', name: string } | null } } };
